// CANONICAL COPY (GH #7115). src/constants/obligations/obl-environmental-threats.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-environmental-threats',
  title: 'Verify protection against physical and environmental threats',
  description:
    "Confirm that protection against physical and environmental threats — including natural disasters, fire, flood, extreme temperature, intentional attack and other foreseeable hazards — is designed, implemented and tested for facilities housing information processing assets. Controls shall be proportionate to the site's risk profile and include fire detection and suppression, water-ingress protection, temperature and humidity control, and emergency response procedures. Review the environmental risk assessment and test records.",
  category: 'assets',
  scfIds: ['SCF-PHY-005'],
  cadence: { frequency: '1y', anchor: 'domain' },
  strategy: 'all',
  fulfilmentCriteria: [
    {
      type: 'document-published',
      description: 'Environmental threat protection standard is published',
    },
    { type: 'document-within-sla', description: 'Standard review is not overdue' },
  ],
  domainActions: [{ type: 'approve-document', label: 'Approve Document' }],
};
